import * as angular from 'angular';
import { UtilService } from 'app/_services/util.service';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpTsoNotice
     * @memberof app
     *
     * @restrict E
     *
     * @description
     * Notice from the TSO.
     *
     * @param {string?} tsoName The name of the TSO whose notice to display. Can be left out if an alternate `title`
     *  was passed.
     * @param {string[]} notice Line feed after every iteration.
     * @param {expression?} [title='Notice from {{tsoName}}'] The title of the notice.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpTsoNotice', pkpTsoNotice);

    function pkpTsoNotice(utilService: UtilService) {
        return {
            restrict: 'E',
            scope: {
                tsoName: '=?',
                notice: '=',
                title: '@'
            },
            template: require('app/_directives/pkp-tso-notice.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.pkpShowMoreId = guidGenerator();
            scope.needsShowMore = needsShowMore;
            scope.uiEnableShowMoreBtn = false;

            /**
             * Tightly coupled to max-width of CSS p.summary class. It compares scroll height and inner height of the
             * paragraph and if they differ, a "show moe" button is required to read further content.
             */
            function needsShowMore() {
                var paragraph = angular.element('#' + scope.pkpShowMoreId);
                if (!paragraph[0]) return;
                scope.uiEnableShowMoreBtn =
                    paragraph[0].scrollHeight > paragraph.innerHeight();
                paragraph.addClass('expanded');
            }

            /**
             * @see http://stackoverflow.com/a/6860916
             * @returns {string}
             */
            function guidGenerator() {
                return utilService.generateGuid();
            }
        }
    }
})();
